// extracted by mini-css-extract-plugin
export default {"filtersContainer":"Results_filtersContainer__FGSxg","icon":"Results_icon__lBEWy","baseline":"Results_baseline__EJh3M","topContainer":"Results_topContainer__iBQJ3"};